import type { Component } from "solid-js";
import { createResource, Show } from "solid-js";
import { useAuthDispatch } from "../state/auth";
import { Navigate } from "@solidjs/router";

const LogoutCallbackPage: Component = () => {
  const { handleLogoutCallback } = useAuthDispatch();
  const [origin] = createResource(() => handleLogoutCallback());

  return (
    <Show when={origin.state === "ready" || origin.state === "errored"} fallback="Loading...">
      <Navigate href={origin() ?? "/"} />
    </Show>
  );
};

export default LogoutCallbackPage;
